var ReportsComponents = angular.module('RessieApp.components.company', [
  'RessieApp.components.company.departure'
]);
